export default __webpack_public_path__ + "media/images/brands/Sonos1-3f76e00eaaf31101e1fca9a7cef84681.png";